import { createApp, ref } from 'vue'

const app = createApp({
  setup() {
    const popupShow = ref(true)
    const closePopup = () => {
      popupShow.value = false
    }
    return { popupShow, closePopup }
  }
})
if (document.getElementById('popupWindow')) {
  app.mount('#popupWindow')
}
